export default __webpack_public_path__ + "2d50093.png";